<template>
    <div class="News" :class="isMobile == 0 ? '' : 'News_mobile'">
        <div :class="isMobile == 0 ? 'News_story_container' : 'News_story_container_mobile'">
            <!-- 大标题：添加动画类 -->
            <div :class="isMobile == 0 ? '' : 'News_big_title_mobile'" class="News_big_title animate-fade-in" v-if="lang.fyType == 2">NEWS</div>
            <div :class="isMobile == 0 ? '' : 'News_big_title_mobile'" class="News_big_title animate-fade-in" v-else>公司新闻</div>

            <!-- 新闻列表：给每个项添加动画类，并通过索引设置延迟 -->
            <router-link v-for="(item, index) in newsList" :key="index" :to="`/news/${item.id}`"

            :class="isMobile == 0 ? '' : 'News_list_mobile'"
                class="News_list animate-fade-in" :style="{ animationDelay: `${0.3 + index * 0.2}s` }">
                <img v-if="isMobile == 0" class="News_img"
                    :src="'https://app.choisiyachts.com' + getImgeList(item.main_image)" alt="" />
                <img v-if="isMobile == 1" class="News_img_mobile"
                    :src="'https://app.choisiyachts.com' + getImgeList(item.main_image)" alt="" />

                <div :class="isMobile == 0 ? 'News_content' : 'News_content_mobile'">
                    <div v-if="isMobile == 0" class="News_title" style="margin-bottom: 10px;"
                        v-html="item.translations.title.content"></div>
                    <div v-if="isMobile == 1" class="News_title_mobile" 
                        v-html="item.translations.title.content"></div>

                    <div v-if="isMobile == 0" class="News_small_title" style="margin-bottom: 20px;"
                        v-html="item.translations.content.content"></div>
                    <div v-if="isMobile == 1" class="News_small_title_mobile" style="margin-bottom: 20px;"
                        v-html="item.translations.content.content"></div>

                    <div :class="isMobile == 0 ? 'News_button' : 'News_button_mobile'">
                        <div :class="isMobile == 0 ? 'News_button_text' : 'News_button_text_mobile'" v-if="lang.fyType == 2">Learn more</div>
                        <div :class="isMobile == 0 ? 'News_button_text' : 'News_button_text_mobile'" v-else>了解更多</div>
                        <img class="News_button_icon" src="../assets/bluenext.png" alt="箭头图标" />
                    </div>
                </div>
            </router-link>
        </div>
        <bottomText></bottomText>
    </div>
</template>

<script>
// 脚本部分保持不变
import { newsList } from '../../request/api.js'
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'BrandStory',
    mounted() {
        this.isMobile = localStorage.getItem('isMobile')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getNewsList('en')
        } else {
            this.getNewsList('zh')
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });

    },
    data() {
        return {
            lang: {},
            newsList: [],

            isMobile: 0
        }
    },
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getImgeList(string) {
            return string.split(',')[0]
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            console.log(this.lang)
            if (this.lang.fyType == 2) {
                this.getNewsList('en')
            } else {
                this.getNewsList('zh')
            }
        },
        getNewsList(language) {
            let data = {
                page: 1,
                limit: 999,
                category: '新闻',
                language
            }
            newsList(data).then(res => {
                this.newsList = res.data.data
            })
        }
    }
}
</script>

<style>
/* 原有样式保持不变 */
.News {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height:100%;
}
.News_mobile{
    height:80%;
}
.News_story_container {
    display: flex;
    flex-direction: column;
    width: 71%;
    margin: 60px auto;
}

.News_story_container_mobile {
    display: flex;
    flex-direction: column;
    width: 94%;
    margin: 15px auto;
}

.News_big_title {
    margin-bottom: 40px;
    text-align: left;
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 36px;
    color: #021131;
}
.News_big_title_mobile{
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 25px;
}
.News_list {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #6488C6;
    padding-bottom: 61px;
    margin-bottom: 40px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.News_list_mobile{
    padding-bottom: 20px;
    margin-bottom: 20px;
}
.News_list:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.News_img {
    margin-right: 60px;
    width: 640px;
    height: 356px;
    border-radius: 0px 0px 0px 0px;
}

.News_img_mobile {
    width: 170px;
    height: 122px;
    margin-right: 20px;
}

.News_content {
    width: 700px;
}

.News_content_mobile {
    width: 50%;
}

.News_title {
    width: 90%;
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 28px;
    color: #021131;
    line-height: 39px;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.News_title_mobile {
    width: 100%;
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #021131;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.News_small_title {
    width: 90%;
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #021131;
    line-height: 25px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.News_small_title_mobile {
    line-height: 25px;
    width: 100%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #021131;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.News_button {
    display: flex;
    align-items: center;
    width: 176px;
    height: 48px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #6488C6;
    justify-content: center;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #6488C6;
    background: white;
    transition: color 0.5s ease;
    position: relative;
    overflow: hidden;
}
.News_button_mobile{
    display: flex;
    align-items: center;
    width: 120px;
    height:28px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #6488C6;
    justify-content: center;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #6488C6;
    background: white;
    transition: color 0.5s ease;
    position: relative;
    overflow: hidden;

}
.News_button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: #6488C6;
    transition: width 0.5s ease;
    z-index: 0;
}

.News_list:hover .News_button {
    color: white;
}

.News_list:hover .News_button::before {
    width: 100%;
}

.News_button_text {
    font-family: Arial, sans-serif;
    z-index: 1;
}
.News_button_text_mobile{
    font-size: 12px;
}
.News_button_icon {
    width: 8px;
    height: 14px;
    margin-left: 10px;
    margin-top: 2px;
    z-index: 1;
}

/* 添加浮现动画相关样式 */
/* 定义淡入+上移动画 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
        /* 初始状态：透明+下移20px */
    }

    to {
        opacity: 1;
        transform: translateY(0);
        /* 结束状态：完全可见+回到原位置 */
    }
}

/* 动画类：应用到需要浮现的元素 */
.animate-fade-in {
    opacity: 0;
    /* 初始透明（避免闪烁） */
    animation: fadeIn 0.8s ease-out forwards;
    /* 0.8秒动画，结束后保持最终状态 */
}

/* 标题单独设置延迟（最先出现） */
.News_big_title {
    animation-delay: 0s;
}
</style>